import Spinner from 'react-bootstrap/esm/Spinner';
import { useFetchData } from '../../../Hooks/Main/useFetchData';
import HtmlDecode from '../../../Utils/HtmlDecode';
import {Link} from "react-router-dom"
import './style.css'
import LazyImage from '../../../Components/LazyImage';
import GetWords from '../../../Utils/GetWords';

const imageUrl = process.env.REACT_APP_FILE_URL


function OurProgram() {
    const lang = localStorage.getItem("i18nextLng");
  const { data, isLoading } = useFetchData("ourPrograms", lang);
  // console.log("programs",data)
    return !isLoading ? (
      <div className="container-fluid m-0 p-0">
        {data && data?.ourPrograms[ 0 ]?.images && (
          <div className="p-0 position-relative d-flex justify-content-center">
            <LazyImage src={`${imageUrl}${data?.ourPrograms[0]?.images?.file}`} className="img img-fluid" alt={data?.ourPrograms[0]?.title} style={{
                aspectRatio: "5/1",
                objectFit: "cover",
                objectPosition: "center",
                width: "100%",
              }}/>
            
            <div className="image-frame__wrapper">
              <h2>{data?.ourPrograms[0]?.title}</h2>
            </div>
        </div>
        )}
        
        
        <div className='container'>
          {data && data?.ourPrograms[ 0 ]?.isTitle && (
          <div className="row mt-4 mx-1">
            <h4 className="text-title">{data?.ourPrograms[ 0 ]?.title}</h4>
            <p className="mt-2">
              <span
                dangerouslySetInnerHTML={{
                  __html: `${HtmlDecode(data?.ourPrograms[ 0 ]?.content)}`,
                }}
              />
            
            </p>
          </div>
        )}
          
          <h4 className="text-title mt-4 mb-4">Our Current Project</h4>
          <div className="row mb-4">
            {data?.ourPrograms?.filter(program => !program.isTitle).map((program, index) => {
              return (
                <div className="col-md-4 ourProgram-container" key={index}>
                  <div className="zoom-content-on-hover border rounded position-relative program-main">
                    <div className="my-image-wrapper h-50 vh-50">
                      {program?.images && (
                        <LazyImage
                          src={`${imageUrl}${program.images?.file}`}
                          className="img img-fluid"
                          style={{
                            aspectRatio: "2/1",
                            objectFit: "cover",
                            maxHeight: "100%",
                            height: "230px",
                            width: "100%",
                          }}
                        />
                      )}
                    </div>
                    <div className="program-title d-flex justify-content-center">
                      <h6 className="program--title fw-light">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${GetWords(HtmlDecode(program?.title))}`,
                          }}
                        />
                      </h6>
                    </div>
                    <div className="programs-content shadow px-3 d-flex flex-column justify-content-between">
                      <p>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${HtmlDecode(
                              program?.content?.substring(0, 170)
                            )}...`,
                          }}
                        />
                      </p>
                      <Link
                        to={`/our-program-details/${program?._id}`}
                        className="text-decoration-none program-link link-title fs-6 fw-inline fw-light mt-auto"
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* <div className="col-md-4 mb-3">
              <div className=" zoom-content-on-hover border rounded">
                <div className="my-image-wrapper h-50 vh-50">
                  <Image
                    src={require("../../../Assets/Images/womenEmp.webp")}
                    fluid
                    style={{
                      aspectRatio: "2/1",
                      objectFit: "cover",
                      maxHeight: "100%",
                      height:"230px",
                      width: "100%",
                    }}
                  />
                </div>
                <h6 className="program-title text-title fw-light">
                  Support women in afghanistan
                </h6>
                <p className="m-5 program-centent">
                  exactord from, excluding front and back matter 6. the body, or substance, of an item of computer data, esp. nonnumerical data, as opposed to the accompanying information necessary for storage,
                  <Link
                    to="/our-program-details"
                    className="text-decoration-none program-link link-title fs-6 fw-inline fw-light"
                  >
                    Read More
                  </Link>
                </p>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className=" zoom-content-on-hover border rounded">
                <div className="my-image-wrapper h-50 vh-50">
                  <Image
                    src={require("../../../Assets/Images/cropped.webp")}
                    fluid
                    style={{
                      aspectRatio: "2/1",
                      objectFit: "cover",
                      maxHeight: "100%",
                      height:"230px",
                      width: "100%",
                    }}
                  />
                </div>
                <h6 className="program-title text-title fw-light">
                  Support women in afghanistan
                </h6>
                <p className="m-5 program-centent">
                  exactord from, excluding front and back matter 6. the body, or substance, of an item of computer data, esp. nonnumerical data, as opposed to the accompanying information necessary for storage,
                  <Link
                    to="/our-program-details"
                    className="text-decoration-none program-link link-title fs-6 fw-inline fw-light"
                  >
                    Read More
                  </Link>
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    ) : (
      <div className="d-flex justify-content-center mt-3">
        <Spinner animation="grow" className="me-2" />
        Loading Content...
      </div>
    );
}

export default OurProgram